module.exports = __webpack_public_path__ + "static/media/galdinsWon_500_1000.967b3d67.png";